import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const BRAND_GATEWAY_TASK = gql`
  ${TASK_VIEW_FIELDS}
  query brandGatewayTask($id: ID!) {
    brandGatewayTask(id: $id) {
      id
      status
      isAwaiting
      awaitingReason
      awaitingReasonComment
      modifiedDate
      reopenedDate
      reopenReason
      currentViewType

      brand {
        id
        name
        website
        isHasNoWebsiteConfirmed
        messinessScore
        rank
        status
        exclusionReason
        exclusionReasonComment
        masterBrand {
          id
          name
          brandGatewayTask {
            id
          }
        }
        slaveBrands {
          id
          name
          locationCount
          brandGatewayTask {
            id
          }
        }
        notSameBrands {
          id
          name
          locationCount
          brandGatewayTask {
            id
          }
        }
        locations {
          id
          brandId
          name
          website
          status
          exclusionReason
          exclusionReasonComment
          formattedAddress
          coordinates {
            latitude
            longitude
          }
          googlePlaceId
          originalBrand {
            id
            name
          }
          duplicateOf {
            id
            name
          }
        }
        modifiedDate
      }
      assignedTo {
        id
        name
      }
      reopenedBy {
        id
        name
      }
      modifiedDate

      miscTaskVerifiedBy {
        id
        name
      }
      miscTaskVerifiedDate
      miscTaskVerifiedComment
      miscTaskQCVerifiedBy {
        id
        name
      }
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
      isAssignable

      relatedTasks {
        brandId
        brandGatewayTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
        brandDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
        menuDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
      }

      views {
        ...TaskViewFields
        modifiedLocationIdsUnreviewedByDefiner
      }
    }
  }
`

export default BRAND_GATEWAY_TASK
